import React,{useState} from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../components/grid-container/GridContainer"
import Logo from "../../../styles/img/custom/renault-top-logo.png"
import { UiLoginContainer, UiLoginCustomContainer, UiLoginPageLogo, UiLoginOptions } from "../components/header/UiTopNavElements"
import { UiModal } from '../components/common/UiModal';
import { LoginPage } from './Auth/LoginPage'

export default function RenaultLandingPage(props) {

    const [showLoginForm, setShowLoginForm] = useState(false);
  
    const showHideLoginForm = () => {
        setShowLoginForm(true);
    };
    const hideLoginForm = () => {
        setShowLoginForm(false);
    };

    return (
        <>
         <UiModal
                handleClose={hideLoginForm}
                show={showLoginForm}
                title="Login"
                subTitle="Welcome back"
            >
               
                <div className="sba-custom-login-form">
                    <LoginPage/>
                </div>
            </UiModal>

            <UiLoginCustomContainer>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="6">
                        <UiLoginPageLogo Logo={Logo} heading="ÉQUIPE"/>
                    </UiCol>
                    <UiCol lg="6" className="sb-login-option">
                        <UiLoginOptions signin={showHideLoginForm}/>
                    </UiCol>
                </UiRowContainer>
            </UiLoginCustomContainer>
        </>
    )
}
